module.exports = __webpack_public_path__ + "static/assets/a0c3f3a11b20c6777738f170e4b00098.svg";